import { MouseEvent, TouchEvent, useCallback } from 'react'

export function useDisableFocus<T extends HTMLElement>(
  isActive?: boolean | (() => boolean),
  onTouchStart_?: (e: TouchEvent<T>) => void,
  onMouseDown_?: (e: MouseEvent<T>) => void,
) {
  const preventFocus = useCallback(
    (e: MouseEvent<T> | TouchEvent<T>) => {
      if (
        isActive === undefined ||
        isActive === true ||
        (typeof isActive === 'function' && isActive())
      )
        e.preventDefault?.()
    },
    [isActive],
  )

  const onTouchStart = useCallback((e: TouchEvent<T>) => {
    onTouchStart_?.(e)
    preventFocus(e)
  }, [])

  const onMouseDown = useCallback((e: MouseEvent<T>) => {
    onMouseDown_?.(e)
    preventFocus(e)
  }, [])

  return { onTouchStart, onMouseDown }
}
